module.exports = __webpack_public_path__ + "static/media/Stopper.c85ab918.svg";